export default function CTA() {
  const handleBooking = () => {
    window.REACT_APP_NAVIGATE('/contact');
  };

  return (
    <section className="py-24 bg-teal-600">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Let's strengthen your operations and support your care
        </h2>
        <button 
          onClick={handleBooking}
          className="bg-white text-teal-600 px-10 py-5 rounded-full text-xl font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer shadow-xl"
        >
          Book an Operations Assessment
        </button>
      </div>
    </section>
  );
}
